import { min, nonNullable } from 'lib/array/arrayUtils'

function getOrderAccommodationStartDate(order: App.Order): string | undefined {
  return min(nonNullable(order.items.map(item => item.reservation?.startDate)))
}

export default getOrderAccommodationStartDate
